export const VALIDATION_DEBOUNCE_TIME = 500;

export const LEARN_MORE_LINK = 'https://help.fiverr.com/hc/en-us/articles/17832447172241';
